module.exports = __webpack_public_path__ + "img/card-slider-video.7ebb4f07.webp";